<template>
    <div style="width: 100%;">
        <!-- <button @click="refresh()">刷新</button> -->
        <!-- {{title}} -->
        <v-chart :style="chart_style()" :options="line" :theme="echartsTheme" :key="echartsTheme" :autoresize="true" />
    </div>
</template>

<script>
	import ECharts from 'vue-echarts'
	import axios from 'axios'
	import moment from 'moment';

	import {
		request_zzquant
	} from "network/request.js"

 

	const dataZoomData = {
		"start": 60,
		"end": 100
	}

	export default {
		props: {
			title: String,
			subText: String,
			symbol_code: String,
			highlightDate: String,
			chart_heigh: {
				type: String,
				default: '600px'
			},
			chart_width: {
				type: String,
				default: '100%'
			},
			chart_rank_line: {
				type: Object,
				default: () => {
					return {
						width: 2,
						opacity: 0.9,
						color: '#E69F00'
					}
				}
			},
		},
		computed: {
			echartsTheme(){ return this.theme==='dark' ? 'site-dark' : null }
		},
		components: {
			'v-chart': ECharts
		},
		watch: {
			symbol_code: 'refresh',
			highlightDate: 'refresh'
		},
data() {
	return {
		theme:'light',
		colorblind: false,
		line: {
					title: {
						text: this.title,
						subtext: this.subText,
						left: '1%',
						// textAlign:'right',
						textStyle: {
							color: '#999999'
						},
						subtextStyle: {
							color: '#666666'
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						}
					},
					axisPointer: {
						link: {
							xAxisIndex: 'all'
						},
						// label: {
						// 	backgroundColor: '#777'
						// }
					},
					legend: {
						top: 10,
						left: 'center',
						data: ['K', 'MA5', 'Volume', '排名'],
						textStyle: {
							color: '#999999'
						},
					},
					visualMap: {
						show: false,
						seriesIndex: 2,
						dimension: 2,
						pieces: [{
							value: 1,
							color: '#0072B2'
						}, {
							value: -1,
							color: '#E69F00'
						}]
					},
					grid: [{
							left: '10%',
							right: '8%',
							height: '50%'
						},
						{
							left: '10%',
							right: '8%',
							top: '63%',
							height: '25%'
						}
					],
					xAxis: [{
							type: 'category',
							scale: true,
							boundaryGap: false,
							axisLine: {
								onZero: false,
								lineStyle: {
									color: '#666666'
								}
							},
							splitLine: {
								show: false
							},
							splitNumber: 20,
							min: 'dataMin',
							max: 'dataMax',
							axisPointer: {
								z: 100
							},
							axisLabel: {
								fontSize: 10,
								color: '#999999'
							},
						},
						{
							gridIndex: 1,
							type: 'category',
							scale: true,
							boundaryGap: false,
							axisLine: {
								onZero: false,
								lineStyle: {
									color: '#666666'
								}
							},
							axisTick: {
								show: false
							},
							splitLine: {
								show: false
							},
							axisLabel: {
								show: false
							},
							splitNumber: 20,
							min: 'dataMin',
							max: 'dataMax'
						}
					],
					yAxis: [{
							scale: true,
							offset: 2,
							splitLine: {
								show: false
							},
							splitArea: {
								show: true
							},
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							position: 'left',
							min: 'dataMin',
							max: 'dataMax',
						},
						{
							scale: true,
							offset: 2,
							position: 'right',
							gridIndex: 1,
							splitNumber: 2,
							axisLabel: {
								show: false
							},
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							splitLine: {
								show: false
							},
						}, {
							scale: true,
							offset: 2,
							splitArea: {
								show: false
							},
							// axisLine: {
							// 	lineStyle: {
							// 		color: '#666666',
							// 		width: 1
							// 	}
							// },
							splitLine: false,
							position: 'right',

						}, {
							name: "排名",
							inverse: true,
							scale: true,
							offset: 10,
							position: 'righ',
							min: 0,
							max: 'dataMax',
							splitNumber: 10,
							splitLine: {
								show: false
							},
							splitArea: {
								show: true
							},
							axisLine: {
								lineStyle: {
									color: '#afadb1',
									width: 1
								}
							},
							axisLabel: {
								interval: 0,
								formatter: '{value}名',
								color: '#999999'
							},
							nameTextStyle: {
								color: '#999999'
							}
						},
					],
					dataZoom: [
						// {
						// 	type: 'inside',
						// 	start: dataZoomData.start,
						// 	end: dataZoomData.end
						// },
						{
							show: true,
							type: 'slider',
							xAxisIndex: [0, 1],
							y: '90%',
							start: dataZoomData.start,
							end: dataZoomData.end,
							textStyle: {
								color: '#999999'
							}
						}
					],
					series: []
				}
			}
		},

mounted() {
	// console.log("mounted");
	this.refresh();
	try{ const t = localStorage.getItem('site.theme'); if(t){ this.theme = t } }catch(e){ console.warn('theme read failed', e) }
    { const c = localStorage.getItem('site.colorblind'); if(c){ this.colorblind = (c==='1' || c==='true') } }
	window.addEventListener('site-theme-changed', this.onThemeChanged)
	window.addEventListener('site-colorblind-changed', this.onColorblindChanged)
},
		beforeDestroy(){ window.removeEventListener('site-theme-changed', this.onThemeChanged); window.removeEventListener('site-colorblind-changed', this.onColorblindChanged) },

		created(){
			this.onThemeChanged = (e)=>{ const t = e && e.detail && e.detail.theme ? e.detail.theme : (localStorage.getItem('site.theme')||'light'); this.theme = t }
			this.onColorblindChanged = (e)=>{ const v = e && e.detail && typeof e.detail.colorblind!=='undefined' ? !!e.detail.colorblind : (localStorage.getItem('site.colorblind')==='1' || localStorage.getItem('site.colorblind')==='true'); this.colorblind = v; this.refresh() }
		},
		methods: {
			chart_style() {
				return {
					width: this.chart_width,
					height: this.chart_heigh,
				}
			},
			calculateMA(dayCount, data) {
				var result = [];
				for (var i = 0, len = data.values.length; i < len; i++) {
					if (i < dayCount) {
						result.push('-');
						continue;
					}
					var sum = 0;
					for (var j = 0; j < dayCount; j++) {
						sum += data.values[i - j][1];
					}
					result.push(+(sum / dayCount).toFixed(2));
				}
				return result;
			},
			refresh(date) {
				this.line['title'] = {
					text: this.title,
					subtext: this.subText,
					// left: 0
					textStyle: {
						color: '#999999'
					},
					subtextStyle: {
						color: '#666666'
					}
				};
				if (!this.symbol_code || this.symbol_code.length != 6) {
					return
				}
				const date_from_rank = moment().add(-6, 'months').format('YYYY-MM-DD');
				axios.all([
                        request_zzquant({
                            'url': 'open/kline/d/' + this.symbol_code
                        }),
						request_zzquant({
							'url': '/v2/api/sentiment/media/ths/symbol/' + this.symbol_code + '?date1=' +
								date_from_rank
						}),
					])
					.then(axios.spread((resp1, resp2) => {
						// console.log(resp1);
						// console.log(resp2);
						let splitDataItem = this.splitData(resp1['data']['data'], resp2['data']['data'], date);

						// 更新title
						// let symbol_name = resp1['data']['data']['name'];
						// this.line['title'] = {
						// 	text: this.title,
						// 	subtext: symbol_name,
						// };
					let series_data = []
					const upColor = this.colorblind ? '#E69F00' : '#ec0000'
					const downColor = this.colorblind ? '#0072B2' : '#00da3c'
						series_data.push({
							name: 'MA5',
							data: this.calculateMA(5, splitDataItem),
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.6
								}
							},
							symbol: 'circle',
						});

						series_data.push({
							name: 'K',
							data: splitDataItem.values,
							type: 'candlestick',
						itemStyle: {
							normal: {
								color: upColor,
								color0: downColor,
								borderColor: upColor,
								borderColor0: downColor,
								borderWidth: 1.5
							}
						},

						});

						series_data.push({
							name: 'Volume',
							data: splitDataItem.vols,
							type: 'bar',
							xAxisIndex: 1,
							yAxisIndex: 1,
						});

						// 涨停位
						series_data.push({
							name: 'last_close',
							data: splitDataItem.values_close_last,
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.6,
								color: upColor
							},
						},
							symbol: 'circle',
							markLine: {
								symbol: 'none', //去掉箭头
								data: [{
									type: 'max',
									name: '涨停位',
									symbol: 'circle',
								}, ]
							}
						});

						// 次日涨停位
						series_data.push({
							name: 'last_close',
							data: splitDataItem.values_next_uplimit,
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.4,
									color: 'gray'
								},
							},
							symbol: 'circle',
							markLine: {
								symbol: 'none', //去掉箭头
								data: [{
									type: 'max',
									name: '涨停位',
									symbol: 'circle',
								}, ]
							}
						});
						//情绪数据
						series_data.push({
							name: '排名',
							data: splitDataItem.attention_rank,
							type: 'line',
							symbol: 'circle',
							showSymbol: true,
							label: {
								show: true,
								formatter: function(params) {
									return splitDataItem.attention_rank[params.dataIndex];
								}
							},
							lineStyle: {
								normal: this.chart_rank_line
							},
							yAxisIndex: 3
						});

						// Check if the highlightDate is in the data
						if (this.highlightDate) {
							let xHighLightDate = this.highlightDate.replaceAll("-", "")
							let highlightIndex = splitDataItem.categoryData.indexOf(xHighLightDate);
							console.log(xHighLightDate)
							if (highlightIndex !== -1) {
								let highlightSeriesMarkLine = {
									name: 'Highlight MarkLine',
									type: 'line',
									markLine: {
										silent: true,
										data: [{
											name: 'highlight line',
											xAxis: xHighLightDate,
											lineStyle: {
												normal: {
													width: 2,
													opacity: 0.6,
													color: 'rgba(135, 206, 235)'
												},
											}
										}]
									}
								};
								series_data.push(highlightSeriesMarkLine);

								// Create a new series for the highlight point on the Volume chart
								let highlightSeriesVolume = {
									name: 'Highlight Volume',
									type: 'scatter',
									symbol: 'pin',
									symbolSize: 15,
									xAxisIndex: 1,
									yAxisIndex: 1,
									data: [
										[xHighLightDate, splitDataItem.vols[highlightIndex][1]]
									] // Use the volume for the y value
								};
								series_data.push(highlightSeriesVolume);
							}
						}


					this.line['xAxis'] = [{
						data: splitDataItem.categoryData,
					}, {
						data: splitDataItem.categoryData,
					}]
					this._klineSplit = splitDataItem
					this.line.tooltip.formatter = (params) => {
						const p = Array.isArray(params) ? params[0] : params
						const idx = p && typeof p.dataIndex === 'number' ? p.dataIndex : 0
						const dateRaw = (p && (p.name || p.axisValue)) || ''
						const dateStr = dateRaw.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
						const wkMap = ['周日','周一','周二','周三','周四','周五','周六']
						const wk = dateStr ? wkMap[new Date(dateStr).getDay()] : ''
						const yv = this._klineSplit && this._klineSplit.values && this._klineSplit.values[idx] ? this._klineSplit.values[idx] : null
						if (!yv) return dateStr
						const open = yv[0]
						const close = yv[1]
						const low = yv[2]
						const high = yv[3]
						const preclose = this._klineSplit.values_preclose && this._klineSplit.values_preclose[idx]
						const volume = (this._klineSplit.vols && this._klineSplit.vols[idx] && this._klineSplit.vols[idx][1]) || ''
						const turnover = this._klineSplit.values_turnover && this._klineSplit.values_turnover[idx]
						const attention = this._klineSplit.attention_total && this._klineSplit.attention_total[idx]
						const rank = this._klineSplit.attention_rank && this._klineSplit.attention_rank[idx]
						const openPct = preclose ? (((open - preclose) / preclose) * 100).toFixed(2) : ''
						const closePct = preclose ? (((close - preclose) / preclose) * 100).toFixed(2) : ''
						const amplitudePct = preclose ? (((high - low) / preclose) * 100).toFixed(2) : ''
						const turnoverPct = (turnover !== undefined && turnover !== '-') ? (Number(turnover) / 100).toFixed(2) : ''
						const volText = typeof volume === 'number' ? volume.toLocaleString() : volume
						const openSign = preclose && open - preclose >= 0 ? '+' : ''
						const closeSign = preclose && close - preclose >= 0 ? '+' : ''
						return [
							`${dateStr} ${wk}`,
							`涨幅: ${closePct ? (closeSign + closePct + '%') : '-'}`,
							`开盘: ${openPct ? (openSign + openPct + '%') : '-'}`,
							`振幅: ${amplitudePct ? (amplitudePct + '%') : '-'}`,
							`换手: ${turnoverPct !== '' ? (turnoverPct + '%') : '-'}`,
							`开盘价: ${open}`,
							`收盘价: ${close}`,
							`最高价: ${high}`,
							`最低价: ${low}`,
							`成交量: ${volText}`,
							`人气: ${attention !== undefined ? attention : '-'}`,
							`排名: ${rank !== undefined ? (rank + '名') : '-'}`
						].join('<br/>')
					}
						// console.log(series_data[0]);
					this.line['series'] = series_data
					if (this.line && this.line.visualMap && Array.isArray(this.line.visualMap.pieces)) {
						this.line.visualMap.pieces[0].color = downColor
						this.line.visualMap.pieces[1].color = upColor
					}
					}))
					.catch(err => {
						console.log(err);
					})
			},
			splitData(rawData, sentiment_symbol) {
				// console.log(111)
				// console.log(rawData);
				let [categoryData, values, values_close, vols, values_close_last, values_next_uplimit, values_preclose, values_turnover] = [
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[]
				]
				let [attention_total, attention_rank] = [
					[],
					[]
				];
				let [x, y, vol] = [rawData['x'], rawData['y'], rawData['vol']]
				let turnover = rawData['turnover'] || []
				let idx_start = 0;
				let idx_end = x.length
				// console.log(date);
				// if (date) {
				// 	date = date.replace(/-/g, '');
				// 	let idx_date = x.indexOf(date);
				// 	idx_end = idx_date + 2;
				// 	if (idx_end > x.length) {
				// 		idx_end = x.length
				// 	}
				// }
				// console.log(idx_end,x.length);
				for (let i = idx_start; i < idx_end; i++) {
					// console.log(i,idx_end,x[i]);
					categoryData.push(x[i]);
					values.push([y[i][0], y[i][1], y[i][3], y[i][2]]);
					values_close.push(y[i][1]);
					values_close_last.push((y[y.length - 1][1]));
					values_preclose.push((y[i].length > 4 && y[i][4] != null) ? y[i][4] : (i > 0 ? y[i-1][1] : y[i][1]))
					values_turnover.push(turnover[i] != null ? turnover[i] : '-')
					if (this.symbol_code.startsWith("30")) {
						values_next_uplimit.push(new Number((y[y.length - 1][1]) * 1.2).toFixed(2));
					} else {
						values_next_uplimit.push(new Number((y[y.length - 1][1]) * 1.1).toFixed(2));
					}
					vols.push([i, vol[i], y[i][0] > y[i][1] ? 1 : -1]);
					//股票情绪数据
					let idx_sentiment = -1;
					for (let si = 0; si < sentiment_symbol.length; si++) {
						let item_sentiment = sentiment_symbol[si];
						if (x[i] == item_sentiment['date1'].replace(/-/g, '')) {
							// console.log(x[i], item_sentiment['date1'], item_sentiment['attention']);
							idx_sentiment = si;
							attention_total.push(item_sentiment['attention']);
							attention_rank.push(item_sentiment['rank']);
							break;
						}
					}
					if (idx_sentiment == -1) {
						attention_total.push(0);
						attention_rank.push(0);
					}
				}
				return {
					categoryData: categoryData,
					values: values,
					values_close: values_close,
					values_close_last: values_close_last,
					values_next_uplimit: values_next_uplimit,
					vols: vols,
					values_preclose: values_preclose,
					values_turnover: values_turnover,
					attention_total: attention_total,
					attention_rank: attention_rank,
				};
			}
		}
	}
</script>

<style>
	.chart_stock_kline_popular {
		width: 100%;
		height: 600px;
	}
</style>
